module.exports = __webpack_public_path__ + "img/6.e4a4b17f.jpg";